export default {
      id: "notifications__refill-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__refill",
      toString: function () {
        return this.url;
      }
    }